import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const MarketplaceProceedServices = () => import('./views/Index.vue');

export default [
  {
    path: '/marketplace-proceed-services',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketplaceadmin' },
    children: [
      {
        path: '',
        name: 'MarketplaceProceedServices',
        component: MarketplaceProceedServices,
        meta: { title: i18n.global.t('marketplaceProceedServices.services') },
      },
    ],
  },
];
